import { useNavigate } from "react-router-dom";
export default function SoulmateCTASection() {
  const navigate = useNavigate();
  return (
    <section className="w-full py-16 bg-gradient-to-r from-gray-100 to-gray-200">
      <div className="max-w-5xl mx-auto px-6">
        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <div className="flex flex-col md:flex-row items-center">
            {/* Image Side */}
            <div className="w-full md:w-1/2 h-64 md:h-auto bg-[#730000] p-8 flex items-center justify-center">
              <div className="text-center">
                <svg
                  className="w-24 h-24 mx-auto text-white opacity-90"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                </svg>
                <div className="mt-4 text-white text-opacity-80 text-sm">
                  Find your perfect match today
                </div>
              </div>
            </div>

            {/* Content Side */}
            <div className="w-full md:w-1/2 p-8 md:p-12">
              <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#730000]">
                Ready to find your soulmate?
              </h2>
              <p className=" mb-8">
                Join thousands of couples who found true love through our
                platform. Your perfect match might be just a click away.
              </p>
              <div className="w-full flex flex-row max-md:items-center max-md:justify-center">
              <button
                onClick={() => navigate("/signup")}
                className="px-8 py-3 bg-[#730000] hover:bg-[#5a0000] text-white text-lg font-medium rounded transition-colors duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
              >
                Sign Up
              </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
